import type { Metadata } from "next";
import type { TypeSeo } from "../types";
import { getCanonicalUrl } from "./getCanonicalUrl";

type ResolvedSeo = TypeSeo<"WITHOUT_UNRESOLVABLE_LINKS", string>;

const NOINDEX_METADATA: Metadata = { robots: { index: false } };

/** `canonicalSlug` is the full path after the origin, e.g. `shop/shop-the-look/fathers-day`. */
export function seoToMetadata(
  seo: ResolvedSeo | undefined,
  canonicalSlug: string,
): Metadata {
  if (!seo) {
    return NOINDEX_METADATA;
  }

  return {
    title: seo.fields.pageTitle,
    description: seo.fields.pageDescription,
    alternates: { canonical: getCanonicalUrl(canonicalSlug) },
    robots: { index: seo.fields.index },
  };
}
